var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.content === true)?_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("fa-check-square")]):(_vm.content === false)?_c('v-icon',{attrs:{"color":"gray"}},[_vm._v("fas fa-times-circle")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }